var _defs, _rect, _text, _rect2, _text2, _rect3, _text3, _rect4, _text4, _rect5, _text5, _rect6, _text6, _rect7, _text7, _rect8, _text8, _rect9, _text9, _rect10, _switch;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgLogoDark = function SvgLogoDark(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "183px",
    height: "57px",
    viewBox: "-0.5 -0.5 183 57",
    content: "<mxfile host=\"www.draw.io\" modified=\"2020-03-26T23:45:37.751Z\" agent=\"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_3) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/80.0.3987.100 Safari/537.36\" version=\"12.7.1\" etag=\"8c9E0G6XcAq8qbJlNT6w\" type=\"google\"><diagram id=\"7ZdvY6w8MIwCxchTOSDL\">7Zhdz9ogFMc/TW9NKfbtclW7Zdmy5XHJrlmLLRktBvFtn36Hp1StaLR5NN40Jg3nD/TA+R2w4OBJtfssybL8LnLKHc/Ndw6eOp4X+B48tbBvBBwHjVBIljcSOgpz9o8a0TXqmuV01WmohOCKLbtiJuqaZqqjESnFtttsIXjX65IU1BLmGeG2+pvlqjQqct1jxRfKitK4jnxTUZG2sRFWJcnF9kTCMwdPpBCqKVW7CeU6dm1cmn7pldrDwCSt1T0dDIgN4Wszt9QMTO3b2Sq6g3clpao4CAiKKyXFXzoRXEhQalFDy2TBOD+TCGdFDWYGo6GgJxsqFYM4fjIVFctz7SbZlkzR+ZJk2ucWkgY0KdZ1TvVAXe0TKlldfKML1VXAGmv3olYpqRjXOfUm/ggljGryB/utbaZmgqXHRHdX44cOVCCbqaiokntoYjqEgTeKwqaXSeZx3JjbY2ZgQ7s8yYlWIyYXi8O7j7igYIhdpocterOBXh960XiEb9NDI/85/MYWv/nArwe/yA3u4fek1edb9H4N9PrQ88IX0guGvfNj9MbhC//5Qove14FeH3pB9EJ6kUXvx0CvD70YvXDnjIevlg/Ri9FdX51PoteeoU/w/SRS6fG9wQQIX2kHdQ7P2UbPyHOnNANCtxE/Et1NNMgzdps/jocjV//OkLkPQBbCdul3iIWRRQwF4aWDAoofAA1Z0Cwe3fhdirC1GtvLC3RPwOG0aQUc4zhO03d4iigmNOTYPVvY0C50kySdXtsFHgEIx6PQ6xJCIxdZkNqrp86y6g0IzOMdzXvdyUUXnv0H</diagram></mxfile>",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.13,
    y: 6,
    width: 30,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 24,
      height: 1,
      paddingTop: 21,
      marginLeft: 3
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 35,
      fontFamily: "Roboto",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "F")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 32,
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: "35px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "F")))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.37,
    y: 6,
    width: 31.5,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 25,
      height: 1,
      paddingTop: 21,
      marginLeft: 24
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 35,
      fontFamily: "Roboto",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "E")))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 37,
    y: 32,
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: "35px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "E")))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 43.37,
    y: 6,
    width: 30,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 24,
      height: 1,
      paddingTop: 21,
      marginLeft: 46
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 35,
      fontFamily: "Roboto",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "S")))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 32,
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: "35px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "S")))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 64.37,
    y: 6,
    width: 30,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 24,
      height: 1,
      paddingTop: 21,
      marginLeft: 67
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 35,
      fontFamily: "Roboto",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "T")))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 79,
    y: 32,
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: "35px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "T")))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 84.87,
    y: 6,
    width: 30,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 24,
      height: 1,
      paddingTop: 21,
      marginLeft: 88
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 35,
      fontFamily: "Roboto",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "E")))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 32,
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: "35px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "E")))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 105.87,
    y: 6,
    width: 30,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 24,
      height: 1,
      paddingTop: 21,
      marginLeft: 109
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 35,
      fontFamily: "Roboto",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "J")))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 121,
    y: 32,
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: "35px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "J")))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 128.37,
    y: 6,
    width: 30,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 24,
      height: 1,
      paddingTop: 21,
      marginLeft: 131
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 35,
      fontFamily: "Roboto",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "O")))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 143,
    y: 32,
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: "35px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "O")))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 151.37,
    y: 6,
    width: 30,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 24,
      height: 1,
      paddingTop: 21,
      marginLeft: 154
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 35,
      fontFamily: "Roboto",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "S")))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 166,
    y: 32,
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: "35px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "S")))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 35,
    width: 167.5,
    height: 19,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 166,
      height: 1,
      paddingTop: 44,
      marginLeft: 7
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Roboto",
      color: "#808080",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "Party Rentals and Event Decor")))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 89,
    y: 48,
    fill: "#808080",
    fontFamily: "Roboto",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Party Rentals and Event Decor")))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: -23.28,
    y: 28.01,
    width: 52,
    height: 3,
    fill: "#70bbfd",
    stroke: "none",
    transform: "rotate(90,2.72,29.51)",
    pointerEvents: "all"
  }))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://desk.draw.io/support/solutions/articles/16000042487",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Viewer does not support full SVG 1.1")))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_dark.3353822f.svg";
export { ForwardRef as ReactComponent };